import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@parcel/ui';
import type * as React from 'react';

/** A shadcn tooltip around one element, in place of the browser's native `title` box. */
export function Hint({
  label,
  side,
  children,
}: {
  label: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: React.ReactElement;
}) {
  if (label == null || label === '') return children;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
